/* Animations accueil — redesign 2026 (reveal, compteurs, titre, tilt, étoiles) */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var d = document;
  if (reduced) return;

  /* ---------- 1. Titre héro : révélation mot à mot ---------- */
  var title = d.querySelector('.at-hero__title');
  if (title && !title.dataset.atWords) {
    title.dataset.atWords = '1';
    var atMobile = window.matchMedia('(max-width: 749px)').matches;
    var delay = atMobile ? 0.05 : 0.22;
    var atStep = atMobile ? 0.06 : 0.13;
    var wrapWords = function (node) {
      var kids = Array.prototype.slice.call(node.childNodes);
      kids.forEach(function (child) {
        if (child.nodeType === 3) {
          var frag = d.createDocumentFragment();
          child.textContent.split(/(\s+)/).forEach(function (part) {
            if (/^\s+$/.test(part) || part === '') { frag.appendChild(d.createTextNode(part)); return; }
            var s = d.createElement('span');
            s.className = 'at-w';
            s.style.animationDelay = delay.toFixed(2) + 's';
            s.textContent = part;
            delay += atStep;
            frag.appendChild(s);
          });
          node.replaceChild(frag, child);
        } else if (child.nodeType === 1) {
          child.classList.add('at-w');
          child.style.animationDelay = delay.toFixed(2) + 's';
          delay += atStep;
        }
      });
    };
    wrapWords(title);
  }

  /* ---------- 2. Reveal au scroll + stagger ---------- */
  var targets = d.querySelectorAll(
    '.at-reassure__item, .at-services__card, .at-sec-head, .at-quote-wrap, ' +
    '.at-features__item, .at-steps__item, .collection-list li, .grid__item .card-wrapper, ' +
    '.at-fcard, .at-acard, .at-bcta__box'
  );
  var groupIndex = {};
  targets.forEach(function (el) {
    if (el.closest('.at-hero')) return;
    var pk = el.parentNode ? (el.parentNode.className || 'x') : 'x';
    groupIndex[pk] = (groupIndex[pk] || 0) + 1;
    el.classList.add('at-reveal');
    el.style.transitionDelay = Math.min((groupIndex[pk] - 1) * 0.09, 0.45).toFixed(2) + 's';
  });

  /* ---------- 3. Étoiles témoignage ---------- */
  d.querySelectorAll('.at-quote__stars').forEach(function (el) {
    if (el.dataset.atStars) return;
    el.dataset.atStars = '1';
    var txt = el.textContent.trim();
    el.textContent = '';
    txt.split('').forEach(function (ch, i) {
      var s = d.createElement('span');
      s.textContent = ch;
      s.style.transitionDelay = (0.15 + i * 0.14).toFixed(2) + 's';
      el.appendChild(s);
    });
  });

  /* ---------- 4. Compteurs (chiffres clés du héro) ---------- */
  var animateCount = function (b) {
    if (b.dataset.atDone) return;
    b.dataset.atDone = '1';
    var raw = b.textContent;
    var m = raw.match(/\d+/);
    if (!m) return;
    var target = parseInt(m[0], 10);
    if (target <= 1) return;
    var t0 = performance.now(), dur = 1300;
    var tick = function (t) {
      var p = Math.min((t - t0) / dur, 1);
      var val = Math.round(target * (1 - Math.pow(1 - p, 3)));
      b.textContent = raw.replace(m[0], val);
      if (p < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };

  /* ---------- 5. IntersectionObserver commun ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('in');
        e.target.querySelectorAll('.at-quote__stars').forEach(function (s) { s.classList.add('in'); });
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -30px 0px' });
    d.querySelectorAll('.at-reveal').forEach(function (el) { io.observe(el); });

    var counterZones = d.querySelectorAll('.at-hero__proof, .at-stats__grid');
    if (counterZones.length) {
      var ioC = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.querySelectorAll('b').forEach(animateCount);
          ioC.unobserve(e.target);
        });
      }, { threshold: 0.4 });
      counterZones.forEach(function (z) { ioC.observe(z); });
    }
  } else {
    d.querySelectorAll('.at-reveal').forEach(function (el) { el.classList.add('in'); });
  }

  /* ---------- 6. Tilt 3D du visuel héro ---------- */
  var visual = d.querySelector('.at-hero__visual');
  var card = d.querySelector('.at-hero__card');
  if (visual && card && window.matchMedia('(pointer: fine)').matches) {
    visual.addEventListener('mousemove', function (e) {
      var r = visual.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      card.style.animation = 'none';
      card.style.transform = 'rotate(1.2deg) perspective(1000px) rotateY(' + (x * 8).toFixed(2) + 'deg) rotateX(' + (-y * 6).toFixed(2) + 'deg)';
    });
    visual.addEventListener('mouseleave', function () {
      card.style.transform = '';
      card.style.animation = '';
    });
  }

  /* ---------- 7. Parallaxe douce du halo héro ---------- */
  var hero = d.querySelector('.at-hero');
  if (hero) {
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = Math.min(window.scrollY, 800);
        hero.style.setProperty('--at-plx', (y * 0.12).toFixed(1) + 'px');
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------- 8. Lien « fiche technique complète » (fiable Safari) ---------- */
  d.querySelectorAll('a[href="#at-description"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = d.getElementById('at-description');
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#at-description');
    });
  });
})();
